<template>
  <router-link v-if="cardLink"
    :to="{ name: 'Детальная новости', params: { alias: news.alias } }"
    class="news-card news-card_link">
    <div class="news-card__image">
      <img class="lazy"
        :src="news.image"
        :alt="news.title+'. Фото №1'">
    </div>
    <div class="news-card__info">
      <AppDate class="news-card__date">
        {{ news.date }}
      </AppDate>
      <h3 v-clamp="3"
        class="news-card__title">
        {{ news.title }}
      </h3>

      <div class="news-card__link">
        <span class="news-card__more">Подробнее</span>
      </div>
    </div>
  </router-link>

  <div v-else
    :class="classes">
    <template v-if="isMain">
      <router-link :to="{ name: 'Детальная новости', params: { alias: news.alias } }"
        :class="{ 'news-main__image': isMain, 'news-card__image': !isMain }">
        <!-- <app-title class="news-all__title" :h1="true">Новости</app-title> -->
        <img class="lazy"
          :src="news.image"
          :alt="news.title+'. Фото №2'">
      </router-link>
      <div class="news-main__info">
        <AppDate class="news-main__date">
          {{ news.date }}
        </AppDate>
        <h3 class="news-main__title">
          {{ news.title }}
        </h3>
        <AppLink class="news-main__link"
          :hasArrow="false"
          :to="{ name: 'Детальная новости', params: { alias: news.alias } }"
          :secondary="true">
          <span>Подробнее</span>
        </AppLink>
      </div>
      
    </template>
    
    <template v-else>
      <router-link :to="{ name: 'Детальная новости', params: { alias: news.alias } }"
        :class="{ 'news-main__image': isMain, 'news-card__image': !isMain }">
        <img class="lazy"
          :src="news.image"
          :alt="news.title+'. Фото №2'">
      </router-link>
      <div class="news-card__info"> 
        <AppDate class="news-card__date">
          {{ news.date }}
        </AppDate>
        <router-link :to="{ name: 'Детальная новости', params: { alias: news.alias } }">
          <h3 v-clamp="3"
            class="news-card__title">
            {{ news.title }}
          </h3>
        </router-link>
        <AppLink class="news-card__link"
          :has-arrow="false"
          :to="{
            name: 'Детальная новости',
            params: { alias: news.alias },
          }"
          :secondary="true">
          <span class="news-card__more">Подробнее</span>
        </AppLink>
      </div>
    </template>
  </div>
</template>

<script>
import { computed, reactive } from "vue";
import AppLink from "@/components/ui/AppLink.vue";
import AppDate from "@/components/ui/AppDate.vue";

export default {
  name: "NewsCard",
  components: {
    AppLink,
    AppDate,
  },

  props: {
    news: {
      type: Object,
      required: true,
    },
    isMain: {
      type: Boolean,
      default: false,
    },
    cardLink: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    props = reactive(props);

    return {
      classes: computed(() => ({
        "news-main": props.isMain,
        "news-card": !props.isMain
      })),
    };
  },
};
</script>

<style lang="scss" scoped>
.news-main {
  $this: &;
  display: flex;
  width: 100%;
  height: 568px;
  background-color: $color_dark-80;
  color: $white;
  transition: box-shadow 0.3s ease;
  border-top-left-radius: 240px;
  border-bottom-right-radius: 240px;
  overflow: hidden;
  margin-bottom: 64px;

  @include phone {
    height: auto;
    flex-direction: column;
    border-top-left-radius: 70px;
    border-bottom-right-radius: 70px;
  }

  &__image {
    flex: 1;
    max-height: 100%;
    width: auto;

    @include phone {
      flex: none;
      height: 400px;
    }

    & img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      max-width: none !important;
    }
  }

  &__info {
    margin-left: auto;
    padding: 45px 112px 56px;
    flex: 0 1 724px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include phone {
      flex: none;
      padding: 33px;
      padding-bottom: 50px;
    }
  }

  &__date {
    font-size: 14px;
    color: $white;
    margin-bottom: 48px;

    @include phone {
      font-size: 12px;
      margin-bottom: 20px;
    }
  }

  &__title {
    font-size: 50px;
    line-height: 120%;

    @include phone {
      font-size: 32px;
      line-height: 120%;
    }
  }

  &__link {
    background: $color_orange-50;
    color: $white !important;
    padding: 16px 66px;
    border-radius: 23px;
    text-align: center;
    margin-top: 32px;
    align-self: flex-start;

    @include phone {
      font-size: 12px;
      line-height: 120%;
      padding: 10px 40px;
      margin-right: auto;
      margin-left: auto;
    }
  }
}

.news-card {
  $this: &;

  display: flex;
  flex-direction: column;
  border-bottom-right-radius: 90px;
  background: $color_dark-20;

  &:hover {
    background: $color_orange-50;

    #{$this} {
      &__title {
        color: $white;
      }

      &__more {
        color: $white;
      }
    }
  }

  @include laptop {
    display: block;
    // border: 1px solid #e8e8e8;
  }

  &__image {
    display: block;
    width: 100%;
    height: 280px;
    flex-shrink: 0;
    transition: box-shadow 0.3s ease;

    @include laptop {
      width: 100%;
      height: auto;
    }

    @include phone {
      display: none;
    }

    #{$this}--main & {
      width: 100%;
      height: 514px;

      @include media($max-width: 1920px) {
        height: calc(514 / 1920 * 100vw);
      }

      @include laptop {
        height: auto;
      }
    }

    .news-detail & {
      width: 100%;
      height: auto;
    }

    img {
      width: 100%;
      height: 100%;

      @include object-fit(cover, center);
      @include lazy-loaded;
    }
  }

  &__info {
    padding: 43px 38px 43px 56px;

    // @include media($max-width: 1920px) {
    //   padding: 20px calc(32 / 1920 * 100vw) calc(12 / 1920 * 100vw);
    // }

    @include desktop {
      padding-bottom: calc(12 / 1535 * 100vw);
    }

    @include laptop {
      padding: 16px 16px 32px;
    }

    .news-detail & {
      padding: 42px 56px;

      @include phone {
        padding: 30px 40px;
      }
    }
  }

  &__date::v-deep {
    margin-bottom: 32px;

    .news-detail & {
      svg {
        display: none;
      }
    }

    @include phone {
      margin-bottom: 12px;
    }
  }

  &__title {
    height: calc(26px * 3);
    margin-bottom: 36px;
    font-size: 20px;
    line-height: 28px;
    color: $color_dark-70;

    @include media($max-width: 1920px) {
      margin-bottom: calc(47 / 1920 * 100vw);
    }

    @include desktop {
      -webkit-line-clamp: 3;
      height: calc(26px * 3);
      margin-bottom: calc(47 / 1535 * 100vw);
    }

    @include laptop {
      height: calc(18px * 2);
      margin-bottom: 0;
      font-size: 14px;
      line-height: 18px;
    }

    .news-detail & {
      height: calc(16px * 3);
      margin-bottom: 0;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
    }
  }

  &__description {
    height: calc(24px * 2);
    margin-bottom: 24px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: $color_dark-70;

    @include media($max-width: 1920px) {
      margin-bottom: calc(24 / 1920 * 100vw);
    }

    @include laptop {
      display: none !important;
    }
  }

  &__more {
    text-transform: uppercase;
    color: $color_orange_50;
    font-size: 14px;
    line-height: 1;
  }

  &_link {
    .news-card__link {
      @include phone {
        margin-top: 16px;
      }
    }
  }
}
</style>
